// src/components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>Email: admin@weonelogistics.com</p>
          <p>Phone: (864) 528-6482</p>
        </div>
        <div className="footer-section">
          <h4>Business Hours</h4>
          <p>Mon-Fri: 8am to 5pm</p>
        </div>
      </div>
      <p className="footer-text">&copy; 2023 WeOne Logistics. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
